module.exports = __webpack_public_path__ + "img/plashka-mobile-ru.e06a8539.jpg";